import { render, staticRenderFns } from "./MyTournamentsView.vue?vue&type=template&id=1bfe2169"
import script from "./MyTournamentsView.vue?vue&type=script&lang=js"
export * from "./MyTournamentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports